import type { App, InjectionKey } from 'vue'
import { useEnvironmentStore } from '@/stores/environmentStore'

export type L10nString = Record<string, string | undefined>

export type DomainTrans = {
  t: (base: string | null | undefined, i18n?: L10nString | null, fallbackLocale?: string) => string
  locale: () => string
}

export const DomainTransKey: InjectionKey<DomainTrans> = Symbol('DomainTrans')

function norm(s: string | null | undefined) {
  return (s ?? '').trim().toLowerCase()
}

function pickText(
  base: string | null | undefined,
  i18n: L10nString | null | undefined,
  locale: string,
  fallbackLocale: string,
) {
  const cur = norm(locale)
  const fb = norm(fallbackLocale) || 'no'

  const vCur = cur && i18n ? i18n[cur] : undefined
  if (vCur && vCur.trim()) return vCur

  const vFb = fb && i18n ? i18n[fb] : undefined
  if (vFb && vFb.trim()) return vFb

  const vAny = i18n ? Object.values(i18n).find(v => v && v.trim()) : undefined
  if (vAny && vAny.trim()) return vAny

  return (base ?? '').trim()
}

export function createDomainTrans(): DomainTrans {
  const env = useEnvironmentStore()

  return {
    locale: () => env.currentLocale,
    t: (base, i18n, fallbackLocale) =>
      pickText(
        base,
        i18n ?? undefined,
        env.currentLocale,
        fallbackLocale ?? import.meta.env.VITE_FALLBACK_LOCALE ?? 'no',
      ),
  }
}

export function installDomainTrans(app: App) {
  app.provide(DomainTransKey, createDomainTrans())
}
